<template>
	<div class="md-layout">
		<div class="md-layout-item">
			<md-card>
				<md-card-header class="md-card-header-icon md-card-header-blue">
					<div class="md-layout">
						<div class="md-layout-item">
							<div class="card-icon">
								<font-awesome-icon class="md-icon" :icon="['fas', 'clipboard-list']"/>
							</div>
							<h4 class="title">Liste des clients actifs</h4>
						</div>
						<div class="md-layout-actions md-layout-item md-size-40 text-right align-center mt-3">
                            <div class="flex items-center">
                                <div class="mr-2">
                                    <md-button class="md-info md-sm md-datatable"
                                               @click="goToRoute('Technicians Assignment')">
                                        <md-icon class="material-icons mr-1">add</md-icon>
                                        <span>Affectation des techniciens</span>
                                    </md-button>
                                </div>
                                <div class="mr-2">
                                    <md-button class="md-info md-sm md-datatable"
                                               @click="goToRoute('Sectors')">
                                        <md-icon class="material-icons mr-1">add</md-icon>
                                        <span>Secteurs</span>
                                    </md-button>
                                </div>
                                <div>
                                    <md-button class="md-info md-sm md-datatable"
                                               @click="goToRoute('Activities')">
                                        <md-icon class="material-icons mr-1">add</md-icon>
                                        <span>Activités</span>
                                    </md-button>
                                </div>
                            </div>
						</div>
					</div>
				</md-card-header>
				<md-card-content class="mt-2">
					<md-table
						:value="clients"
						:md-sort.sync="currentSort"
						:md-sort-order.sync="currentSortOrder"
						:md-sort-fn="customSort"
						class="paginated-table table-hover"
					>
						<md-table-toolbar>
                            <md-field>
                                <label for="pages">Éléments à afficher</label>
                                <md-select v-model="pagination.perPage" name="pages">
                                    <md-option
                                        v-for="item in pagination.perPageOptions"
                                        :key="item" :label="item" :value="item">
                                        {{ item }}
                                    </md-option>
                                </md-select>
                            </md-field>

                            <md-field>
                                <md-input
                                    type="search"
                                    clearable
                                    style="width: 250px"
                                    placeholder="Rechercher..."
                                    v-model="searchQuery"
                                >
                                </md-input>
                            </md-field>
						</md-table-toolbar>

						<md-table-row slot="md-table-row" slot-scope="{ item }">
							<md-table-cell md-label="#" style="max-width: 75px;">
								{{ item.id }}
							</md-table-cell>
							<md-table-cell md-label="Code EBP" style="max-width: 100px;">
								{{ item.code_ebp }}
							</md-table-cell>
							<md-table-cell md-label="Nom" style="max-width: 450px; width: 450px;">
								<span class="text-info cursor-pointer"
									@click="goToRoute('Client Details', item.id)">
									{{ item.name }}
								</span>
							</md-table-cell>
							<md-table-cell md-label="Groupes" style="max-width: 400px; width: 400px;">
								{{ item.groups }}
							</md-table-cell>
							<md-table-cell md-label="Type" style="max-width: 125px;">
								{{ item.type }}
							</md-table-cell>
							<md-table-cell md-label="" style="max-width: 75px;">
								<md-button class="md-info md-simple" style="width: 100%; text-align: center; padding: 0;"
									  @click="goToRoute('Client Details', item.id)">
									Fiche
								</md-button>
							</md-table-cell>
						</md-table-row>
					</md-table>
				</md-card-content>
				<md-card-actions md-alignment="space-between">
					<p class="card-category">
						Affichage des éléments {{ from + 1 }} à {{ to }} sur {{ pagination.total }} éléments
					</p>
					<pagination
						class="pagination-no-border pagination-info"
						v-model="pagination.currentPage"
						:per-page="pagination.perPage"
						:total="pagination.total"
                        @input="getClients"
					>
					</pagination>
				</md-card-actions>
			</md-card>
		</div>
	</div>
</template>

<script>
import { Pagination } from "@/components";
import Fuse from "fuse.js";

export default {
	name: "Clients",
	components: {
		Pagination
	},
	computed: {
		/***
		 * Returns a page from the searched data or the whole data. Search is performed in the watch section below
		 */
		queriedData() {
			let result = this.clients;
			if (this.searchedData.length > 0) {
				result = this.searchedData;
			}
			return result.slice(this.from, this.to);
		},
		to() {
			let highBound = this.from + this.pagination.perPage;
			if (this.pagination.total < highBound) {
				highBound = this.pagination.total;
			}
			return highBound;
		},
		from() {
			return this.pagination.perPage * (this.pagination.currentPage - 1);
		},
        total() {
            return this.searchedData.length > 0
                ? this.searchedData.length
                : this.clients.length;
        },
	},
	data() {
		return {
			currentSort: "name",
			currentSortOrder: "desc",
			pagination: {
				perPage: 50,
				currentPage: 1,
				perPageOptions: [10, 25, 50, 100],
				total: 0
			},
			searchQuery: "",
			propsToSearch: ["id", "name", "code_ebp", "groups", "type", "state"],
			clients: [],
			searchedData: [],
			fuseSearch: null
		};
	},
	methods: {
		customSort(value) {
			return value.sort((a, b) => {
				const sortBy = this.currentSort;
				if (this.currentSortOrder === "desc") {
					return a[sortBy].localeCompare(b[sortBy]);
				}
				return b[sortBy].localeCompare(a[sortBy]);
			});
		},
		goToRoute(route, id = null) {
			this.$router.push({ name: route, params: { id } })
		},
		clientGroups(groups) {
			return groups.map(group => { return group.name }).join(' - ')
		},
        async getClients() {
            const response = await this.$store.dispatch('clients/getClients', { page: this.pagination.currentPage, perPage: this.pagination.perPage, search: this.searchQuery })
            // Formatage pour la recherche
            this.clients = response.data.data.map(client => {
                return {
                    ...client,
                    groups: this.clientGroups(client.groups),
                    type: client.type ? client.type.name : ''
                }
            })
            this.pagination.total = response.data.total
        }
	},
	mounted() {
		this.getClients()
	},
	watch: {
		searchQuery() {
            this.getClients()
        }
	}
}
</script>

<style scoped lang="scss">
.md-datatable::v-deep {
    max-height: 33px;
    min-height: 33px;
    width: 100%;

    .md-ripple {
        padding: 0 1rem !important;
    }
}

.md-layout-actions.md-layout-item {
    padding-right: 0;
}

::v-deep {
    .md-button-content {
        i {
            font-size: 1.1rem !important;
            height: 17px !important;
            width: 15px !important;
            min-width: 15px !important;
        }

        span {
            height: 17px;
            line-height: 18px;
        }
    }
}
</style>
